import { CommonEnums } from '../../common.enums';
import { LAttribute } from './lattribute';
import { Attribute } from './attribute';
import { MJnr_Inst_Cnd } from './mjnr_inst_cnd';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { LAttributesUtil } from 'src/app/shared/grids/lattributes/lattributes.util';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from 'src/app/shared/utils/db_propertytypes.util';
import { MJnr_Inst_CndsUtil } from 'src/app/shared/utils/mJnr_inst_cnds.util';
import { AttributesUtil } from 'src/app/shared/grids/attributes/attributes.util';
import { MJnr_Inst } from './mjnr_inst';

export class MJoiner {
    mJnr_Inst: MJnr_Inst;
    mJnr_Inst_Cnds: Array<MJnr_Inst_Cnd>;

    lAttributes: Array<LAttribute>;
    attributes: Array<Attribute>;

    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;

    nativeDbTyp_Id: number;

    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;

    is_In_SubFlow: string;
    sel_Run_PropertyType_Cd: string;

    change_Ind: string;

    gen_Tab_Change_Ind: string;
    prop_Tab_Change_Ind: string;
    attr_Tab_Change_Ind: string;
    gAttr_Tab_Change_Ind: string;
    rProp_Tab_Change_Ind: string;

    error_Cd: string;
    error_Msg: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.mJnr_Inst = new MJnr_Inst();
        this.mJnr_Inst_Cnds = new Array<MJnr_Inst_Cnd>();
        this.lAttributes = new Array<LAttribute>();
        this.attributes = new Array<Attribute>();
        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();

        this.nativeDbTyp_Id = CommonEnums.defaults.LONG_VAL;

        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.is_In_SubFlow = CommonEnums.defaults.STRING_EMPTY;
        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.prop_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.rProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gAttr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.attr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
    }

    copy(): MJoiner {
        let mJoinerTmp: MJoiner = new MJoiner();

        mJoinerTmp.mJnr_Inst = this.mJnr_Inst.copy();
        mJoinerTmp.mJnr_Inst_Cnds = MJnr_Inst_CndsUtil.getInstance().copy(this.mJnr_Inst_Cnds);
        mJoinerTmp.lAttributes = LAttributesUtil.getInstance().copy(this.lAttributes);
        mJoinerTmp.attributes = AttributesUtil.getInstance().copy(this.attributes);

        mJoinerTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        mJoinerTmp.change_Ind = this.change_Ind;
        mJoinerTmp.error_Cd = this.error_Cd;
        mJoinerTmp.error_Msg = this.error_Msg;
        mJoinerTmp.ref_Id = this.ref_Id;
        mJoinerTmp.ref_Cd = this.ref_Cd;
        mJoinerTmp.fldr_Id = this.fldr_Id;
        mJoinerTmp.is_In_SubFlow = this.is_In_SubFlow;

        mJoinerTmp.run_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.run_Properties);
        mJoinerTmp.runPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.runPropertyTypes);
        mJoinerTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;

        mJoinerTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        mJoinerTmp.prop_Tab_Change_Ind = this.prop_Tab_Change_Ind;
        mJoinerTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;
        mJoinerTmp.gAttr_Tab_Change_Ind = this.gAttr_Tab_Change_Ind;
        mJoinerTmp.attr_Tab_Change_Ind = this.attr_Tab_Change_Ind;

        return mJoinerTmp;
    }

    static parse(mJoinerTmp: MJoiner): MJoiner {
        let mJoiner: MJoiner = new MJoiner();
        mJoiner.copyFrom(mJoinerTmp);
        return mJoiner;
    }

    copyFrom(mJoinerTmp: MJoiner): void {
        this.mJnr_Inst.copyFrom(mJoinerTmp.mJnr_Inst);

        MJnr_Inst_CndsUtil.getInstance().copyFrom(this.mJnr_Inst_Cnds, mJoinerTmp.mJnr_Inst_Cnds);
        LAttributesUtil.getInstance().copyFrom(this.lAttributes, mJoinerTmp.lAttributes);
        AttributesUtil.getInstance().copyFrom(this.attributes, mJoinerTmp.attributes);

        this.nativeDbTyp_Id = mJoinerTmp.nativeDbTyp_Id;
        this.change_Ind = mJoinerTmp.change_Ind;
        this.error_Cd = mJoinerTmp.error_Cd;
        this.error_Msg = mJoinerTmp.error_Msg;
        this.ref_Id = mJoinerTmp.ref_Id;
        this.ref_Cd = mJoinerTmp.ref_Cd;
        this.fldr_Id = mJoinerTmp.fldr_Id;
        this.is_In_SubFlow = mJoinerTmp.is_In_SubFlow;
        this.sel_Run_PropertyType_Cd = mJoinerTmp.sel_Run_PropertyType_Cd;

        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.run_Properties, mJoinerTmp.run_Properties);
        Db_PropertyTypesUtil.getInstance().copyFrom(this.runPropertyTypes, mJoinerTmp.runPropertyTypes);

        this.gen_Tab_Change_Ind = mJoinerTmp.gen_Tab_Change_Ind;
        this.prop_Tab_Change_Ind = mJoinerTmp.prop_Tab_Change_Ind;
        this.rProp_Tab_Change_Ind = mJoinerTmp.rProp_Tab_Change_Ind;
        this.gAttr_Tab_Change_Ind = mJoinerTmp.gAttr_Tab_Change_Ind;
        this.attr_Tab_Change_Ind = mJoinerTmp.attr_Tab_Change_Ind;
    }

    compare(mJoinerTmp: MJoiner) {
        let diffString: string = this.mJnr_Inst.compare(mJoinerTmp.mJnr_Inst);
        if( diffString != '') return diffString;

        diffString = this.toBaseCompare(mJoinerTmp);
        if (diffString != '') return diffString;

        diffString = MJnr_Inst_CndsUtil.getInstance().compare(this.mJnr_Inst_Cnds, mJoinerTmp.mJnr_Inst_Cnds);
        if (diffString != '') return diffString;

        diffString = LAttributesUtil.getInstance().compare(this.lAttributes, mJoinerTmp.lAttributes);
        if (diffString != '') return diffString;

        diffString = AttributesUtil.getInstance().compare(this.attributes, mJoinerTmp.attributes);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.run_Properties, mJoinerTmp.run_Properties);
        if (diffString != '') return diffString;

        diffString = Db_PropertyTypesUtil.getInstance().compare(this.runPropertyTypes, mJoinerTmp.runPropertyTypes);
        if (diffString != '') return diffString;

        return '';
    }

    toBaseCompare(mJoinerTmp: MJoiner): string {
        let baseString: string = this.toBaseString();
        let baseTmpString: string = mJoinerTmp.toBaseString();

        if (baseString != baseTmpString) {
            return baseString + ', ' + baseTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "MJoiner [mJnr_Inst=" + this.mJnr_Inst.toString() + this.toBaseString() +
            ", mJnr_Inst_Cnds=" + MJnr_Inst_CndsUtil.getInstance().toString(this.mJnr_Inst_Cnds) +
            ", lAttributes=" + LAttributesUtil.getInstance().toString(this.lAttributes) +
            ", attributes=" + AttributesUtil.getInstance().toString(this.attributes) +
            ", run_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.run_Properties) +
            ", runPropertyTypes=" + Db_PropertyTypesUtil.getInstance().toString(this.runPropertyTypes);
            
            if(isNotCompare) {
                str += ", change_Ind=" + this.change_Ind + ", error_Cd=" + this.error_Cd +
                ", error_Msg=" + this.error_Msg + ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd +
                ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind + ", prop_Tab_Change_Ind=" + this.prop_Tab_Change_Ind +
                ", attr_Tab_Change_Ind=" + this.attr_Tab_Change_Ind + ", rProp_Tab_Change_Ind=" + this.rProp_Tab_Change_Ind +
                ", gAttr_Tab_Change_Ind=" + this.gAttr_Tab_Change_Ind;
            }

            str += "]";
            return str;
    }

    toBaseString(): string {
        return ", nativeDbTyp_Id=" + this.nativeDbTyp_Id + ", fldr_Id=" + this.fldr_Id + 
        ", is_In_SubFlow=" + this.is_In_SubFlow + ", sel_Run_PropertyType_Cd=" + this.sel_Run_PropertyType_Cd;
    }
}